import { Box, Button, Stack, Typography, useTheme } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { BANNER_HEIGHT } from './Banner';
import useImpersonationBanner from '../../hooks/navigation/useImpersonationBanner';
import { formatMinutesSeconds } from '../../utils/global/helper';

function ImpersonationBanner() {
  const theme = useTheme();
  const { isBannerShown, business, msRemaining, exit, isExiting } =
    useImpersonationBanner();

  if (!isBannerShown) return null;

  return (
    <Box
      bgcolor={theme.palette.warning.main}
      width="100vw"
      height={BANNER_HEIGHT}
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ position: 'relative' }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        gap={1.5}
        color="text.primary">
        <VisibilityIcon fontSize="small" />
        <Typography variant="h5" color="inherit">
          Impersonating {business?.name ?? 'shop'} — ends in{' '}
          {formatMinutesSeconds(msRemaining / 1000)}
        </Typography>
      </Stack>
      <Button
        variant="contained"
        color="inherit"
        size="small"
        onClick={exit}
        disabled={isExiting}
        sx={{
          position: 'absolute',
          right: '10px',
          textTransform: 'none',
          fontWeight: 600,
        }}>
        {isExiting ? 'Exiting…' : 'Exit Impersonation'}
      </Button>
    </Box>
  );
}

export default ImpersonationBanner;
